import React from 'react';

const UserDetail: React.FC = () => {
  return <div>UserDetail</div>;
};

export default UserDetail;
